export default __webpack_public_path__ + "static/O0109-94779e5b08cef592427d7f05a1615210.png";